module.exports = __webpack_public_path__ + "img/stonesettings.4cdcdd3.jpg";